export const USER_ROLES = [
  'developer',
  'admin',
  'dyrektor_sprzedazy',
  'marketing',
  'handlowiec',
  'kierownik',
  'inzynier',
  'zaopatrzenie',
  'klient',
] as const;

export type UserRole = (typeof USER_ROLES)[number];

export const USER_ROLE_LABELS: Record<UserRole, string> = {
  developer: 'Developer',
  admin: 'Administrator',
  dyrektor_sprzedazy: 'Dyrektor sprzedaży',
  marketing: 'Marketing',
  handlowiec: 'Handlowiec',
  kierownik: 'Kierownik budowy',
  inzynier: 'Inżynier',
  zaopatrzenie: 'Zaopatrzenie',
  klient: 'Klient (inwestor)',
};

/**
 * Role z pelnymi uprawnieniami administracyjnymi. `developer` ma wszystko co
 * `admin` plus ekskluzywne ekrany (Import legacy, Cloudflare usage).
 *
 * Wszedzie gdzie sprawdzamy `role === 'admin'` MUSIMY teraz uwzgledniac
 * `developer`. Helper poniżej.
 */
export const ADMIN_ROLES = ['developer', 'admin'] as const satisfies readonly UserRole[];

/**
 * Helper: czy rola ma uprawnienia administracyjne (admin lub developer)?
 * Zaakceptuje undefined/null (typowo z `user?.role`).
 */
export function isAdminRole(role: UserRole | null | undefined): boolean {
  if (role === null || role === undefined) return false;
  return (ADMIN_ROLES as readonly UserRole[]).includes(role);
}

/**
 * Role aktywne w Fazie 1 (CRM + Leady).
 * Pozostale role istnieja w schemacie ale nie maja uprawnien do CRM.
 */
export const PHASE_1_ACTIVE_ROLES = [
  'developer',
  'admin',
  'dyrektor_sprzedazy',
  'marketing',
  'handlowiec',
] as const satisfies readonly UserRole[];

export type Phase1ActiveRole = (typeof PHASE_1_ACTIVE_ROLES)[number];

export function isPhase1ActiveRole(role: UserRole): role is Phase1ActiveRole {
  return (PHASE_1_ACTIVE_ROLES as readonly UserRole[]).includes(role);
}
